function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScNotifications = function SvgScNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19M13 4.08296V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V4.08296M13 4.08296C12.6748 4.0284 12.3407 4 12 4C11.6593 4 11.3252 4.0284 11 4.08296M13 4.08296C15.8377 4.55904 18 7.027 18 10C18 12.761 18.0074 15.0148 19.2729 17.5459C19.6054 18.2108 19.1253 19 18.382 19H5.61803C4.87465 19 4.39462 18.2108 4.72707 17.5459C5.99259 15.0148 6 12.761 6 10C6 7.027 8.16229 4.55904 11 4.08296",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
};
export default SvgScNotifications;